import { FC } from '@Common/Services'

const emailRegex = /^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/

export const fetchAgency = (agencyCode) => async () => {
  try {
    const data = await FC.service('public').get('agencyInfo', { query: { agency: agencyCode } })
    return data
  } catch (err) {
    return null
  }
}

export const getDisabledDays = (fromDate) => {
  const dates = []
  const date = fromDate ? new Date(fromDate) : new Date()
  for (let i = 0; i < 365; i++) {
    date.setDate(date.getDate() - 1)
    const a = new Date(date)
    dates.push(a)
  }
  return dates
}

export const createQuote = async (request) => {
  const results = document.getElementsByClassName('invalid-input')
  if (results.length) return window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Compilare tutti i campi obbligatori!' })
  const data = await FC.service('public').create(request, { query: { action: 'requestQuote' } })
  data
    ? window.growl.show({ severity: 'success', summary: 'Richiesta inviata', detail: 'Richiesta inviata con successo!' })
    : window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Errore durante l\'invio della richiesta!' })
  return !!data
}

export const checkRegexErr = (id, value) => {
  switch (id) {
    case 'clientEmail':
      return !emailRegex.test(value)
    case 'user':
      return value?.length < 10
    default:
      return false
  }
}

export const GRID = [`
'fromLocation fromLocation fromLocation fromLocation fromLocation fromLocation'
'toLocation toLocation toLocation toLocation toLocation toLocation'
'fromDate fromDate fromDate toDate toDate toDate'
`,
  `
'numAdults numAdults numChildren numChildren childrenAge childrenAge'
'clientName clientName clientName clientLastName clientLastName clientLastName'
'clientEmail clientEmail clientEmail user user user'
`
]

export const GRID_SMALL = [
  "'fromLocation''toLocation''fromDate''toDate'",
  "'numAdults''numChildren''childrenAge''clientName''clientLastName''clientEmail''user'"
]
